<template>
    <modal v-if="isShown"  >
        <div slot="header">
            <h4>Enregistrer une carte</h4>
            <a @click="$parent.togglePaymentCardModal()" href="#" class="btn pull-right closeWindow">
                <i class="fas fa-times fa-2x"></i>
            </a>
        </div>
        <div slot="body">
                <stripe-element-card
                    ref="elementsRef"
                    :pk="publishableKey"
                    @token="tokenCreated"
                />
                <button @click.prevent="submit" :disabled="loading">Enregistrer la carte</button>
                <div class="fas fa-spinner" v-if="loading"></div>

            <div v-if="status=='error'">
                <div class="alert alert-danger" role="alert"> {{ customError }} </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import { StripeElementCard } from '@vue-stripe/vue-stripe';
    import Modal from "../Modal";
    export default {
        name: 'registerPaymentCard',
        props : {
            showCardModal: {
                default: false,
                type: Boolean
            },
            bookingSelectedCustomer:{
                type: Object,
                default: ()=>{
                    return []
                }
            }
        },
        components: {
            Modal,
            StripeElementCard,
        },
        data: function () {
            return {
                publishableKey: process.env.MIX_STRIPE_KEY,
                token: null,
                isShown: this.showCardModal,
                intentToken: '',
                stripe:'',
                last4 : '',
                customError: '',
                status: '',
                loading:false
            }
        },
        methods: {
            submit () {
                this.$refs.elementsRef.submit();
            },
            tokenCreated (token) {

                //set token and submit payment method
                this.token = token
                this.submitPaymentMethod(token)

            },

            submitPaymentMethod(token){

                let self = this
                self.loading = true
                this.$refs.elementsRef.stripe.createPaymentMethod(
                    {
                        type: 'card',
                        card: this.$refs.elementsRef.elements.getElement('card'),
                        billing_details: {
                            name: this.bookingSelectedCustomer.fullName,
                        },
                    }
                ).then(function(result) {
                    if (result.error) {
                        // Display error.message
                        self.$snotify.error(result.error.message)
                    } else {
                        // You have successfully created a new PaymentMethod
                        self.savePaymentMethod(result.paymentMethod.id,token.card.last4);
                    }
                })

            },

            savePaymentMethod( method, last4 ){
                //set last4
                this.last4 = last4
                let self = this
                axios.post('/customer/payments', {
                    payment_method: method,
                    customerId: this.bookingSelectedCustomer.id,
                    card_last_four: last4
                }).then(function(){
                    // You have successfully created a new PaymentMethod
                    self.$parent.setLast4(self.last4)
                    self.$parent.togglePaymentCardModal()
                    self.$snotify.success('Carte enregistrée avec succès !')
                    self.loading = false

                }).catch(function (e) {
                    //this code has to be improved to add e.error.message ...
                    self.status = 'error'
                    self.customError= 'Le numéro de carte ou la date d\'expiration est incorrect. ' +
                        'Vérifiez le numéro de la carte ou la date d\'expiration ou utilisez une autre carte'//on a l'erreur pour les dates d'expiration aussi
                });
            },
            initErrorBox(){
                this.status = '',
                this.customError = ''
            }
        },
        watch: {
            showCardModal: function (newVal, oldVal) {
                this.isShown = newVal
                this.initErrorBox()
            }
        }
    }
</script>
<style scoped>
    .fa-spinner {
        color: #114753;
        animation: spin 5s linear infinite;
    }

</style>
